import getLocalLead from './getLocalLead';
import Lead from '../entities/Lead';
import paths from '../routes/paths';
import qs from 'query-string';

function redirectTo(path) {
  window.location.replace(path);
  return { success: false };
}

async function privateRouteControl() {
  const localLead = getLocalLead();
  const actualPath = window.location.pathname;
  const params = qs.parse(window.location.search);
  const hasCodePermission = !!params.code;

  if (actualPath === paths.activate) {
    return { success: true };
  }

  const pathIsNotPrivate = !Object.keys(paths).includes(
    actualPath.replace('/', '')
  );
  if (pathIsNotPrivate) {
    return { success: true };
  }

  if (actualPath === paths.permissions && hasCodePermission) {
    return { success: false, reauth: true, code: params.code };
  }

  if (!localLead.success) {
    return redirectTo(paths.activate);
  } else {
    const lead = await Lead.build(localLead.data);
    switch (actualPath) {
      case paths.permissions:
        if (!lead.prospect.acceptedTerms) {
          return redirectTo(paths.acceptTerms);
        }
        break;
      case paths.install:
        if (!lead.prospect.acceptedTerms) {
          return redirectTo(paths.acceptTerms);
        } else if (!lead.prospect.grantedPermissions) {
          return redirectTo(paths.permissions);
        }
        break;
      default:
        break;
    }

    return { success: true };
  }
}

export default privateRouteControl;
